// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a93dd50c","851":"56204117"}[chunkId] + ".chunk.js";
};